'use client';

import { c as _c } from "react/compiler-runtime";
import { AvatarWithSettings } from './AvatarWithSettings';
import { useNewPostContext } from './NewPostContext';
import { NewPostInputSection } from './NewPostInputSection';
export const InlineReplyLayout = () => {
  const $ = _c(6);
  const {
    parentIsPrivate
  } = useNewPostContext();
  const t0 = !parentIsPrivate;
  let t1;
  if ($[0] !== parentIsPrivate || $[1] !== t0) {
    t1 = <AvatarWithSettings hidePrivate={t0} parentIsPrivate={parentIsPrivate} size={35} className="mr-1.5 self-start" />;
    $[0] = parentIsPrivate;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="min-w-0 flex-1 rounded-xl bg-background-secondary px-2 py-1.5"><NewPostInputSection /></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="flex min-w-0 flex-row">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};